<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit subject Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Subject</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input a subject name!' }, {max: 30, message: 'Must not exceed 30 characters!'}]}]"
            />
          </a-form-item>
          <a-form-item label="Abbreviation">
            <a-input
              placeholder="Abbreviation"
              v-decorator="['abbreviation', {rules: [{ required: true, message: 'Please input a subject abbreviation!' }, {max: 10, message: 'Must not exceed 10 characters!'}]}]"
            />
          </a-form-item>
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { pick, mapValues } from 'lodash'

export default {
  name: 'EditSubject',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      subjectId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openSubjectEditModal', this.showModal)
  },
  methods: {
    showModal: function(subjectId) {
      this.subjectId = subjectId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/subject/' + subjectId).then(({ data }) => {
        const editData = pick({ ...data.data }, ['name', 'abbreviation', 'description'])
        const fieldsData = mapValues({ ...editData }, function(value) {
          return value !== null ? value : undefined
        })
        this.form.setFieldsValue(fieldsData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/subject/' + this.subjectId, {
                  name: values.name,
                  abbreviation: values.abbreviation.toUpperCase(),
                  description: values.description,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Subject details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
